<div class="row g-4 mb-5">
  <div class="col-lg-6">
    <div class="card shadow-sm">
      <div class="card-body text-center">
        <h5 class="card-title">Aktueller Platz</h5>
        @if (rank === undefined) {
          <p class="card-text placeholder-wave">
            <span class="placeholder col-2"></span>
          </p>
        }
        @if (rank === null) {
          <p class="card-text"><span> - </span></p>
        }
        @if (rank !== null && rank !== undefined) {
          <p class="card-text"><span>{{ rank }}</span></p>
        }
      </div>
    </div>
  </div>
  <div class="col-lg-6">
    <div class="card shadow-sm">
      <div class="card-body text-center">
        <h5 class="card-title">Aktuelle Punkte</h5>
        @if (points === undefined) {
          <p class="card-text placeholder-wave">
            <span class="placeholder col-2"></span>
          </p>
        }
        @if (points === null) {
          <p class="card-text"><span> - </span></p>
        }
        @if (points !== null && points !== undefined) {
          <p class="card-text"><span>{{ points }}</span></p>
        }
      </div>
    </div>
  </div>
</div>
<!--<div *ngIf="rank == undefined && points == undefined" class="alert alert-info" role="alert">-->
<!--  Hier könnte dein Ranking stehen. Mache also beim nächsten Event mit!-->
<!--</div>-->
